import type { MailboxInfo } from 'owa-client-types';
import { CalendarCloudSettingType } from '../store/schema/CalendarCloudSettingType';
import getCalendarCloudSettings from './getCalendarCloudSettings';
import type { CalendarFiltersTypes } from '../store/schema/CalendarEventsFilters';

export default function getCalendarFilterCloudSettings(
    mailboxInfo: MailboxInfo
): Map<CalendarFiltersTypes, string[]> | undefined {
    const accountSettings = getCalendarCloudSettings(mailboxInfo);

    const calendarFiltersSetting = accountSettings.get(
        CalendarCloudSettingType.CalendarFilters.toLowerCase()
    );

    return calendarFiltersSetting != null
        ? (calendarFiltersSetting.value as Map<CalendarFiltersTypes, string[]>)
        : undefined;
}
